import FormLogin from "../../common/security/FormsLogin";

const Login = () => {
    return (<>
        <FormLogin/>
    </>)
}
export default Login;